// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/circle-alert.js';

import { paths } from '../generated/circle-alert';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('circle-alert', Original, paths);
